<template>
  <div class="profile-card overflow-hidden bg-blue-gradient2 mb-5 p-5">
    <div class="profile-card-bg">
      <img
        src="@/assets/img/bg/card-bg-01.png"
        class="profile-card-bg-1"
        alt=""
      />
    </div>
    <div class="row align-items-center row-gap-3">
      <div class="col-lg-6">
        <div class="d-flex align-items-center">
          <span
            class="avatar avatar-xxl avatar-rounded me-3 border border-white border-2 position-relative"
          >
            <img
              :src="`${authUrl}/storage/photo/${authStore.currentUser?.photo}`"
              alt=""
            />
            <span class="verify-tick"><i class="isax isax-verify5"></i></span>
          </span>
          <div>
            <h5 class="mb-1 text-white d-inline-flex align-items-center">
              {{ authStore.currentUser?.nickname }}
            </h5>
            <p class="text-light">Student</p>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div
          class="d-flex align-items-center justify-content-lg-end flex-wrap gap-2"
        >
          <div class="rounded px-4 py-2 bg-secondary text-white">
            Points: {{ userStore.getStudentPoint(authStore.currentUser?.id) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useAuthStore } from "@/stores/auth-store";
import { getAuthHostName } from "@/utils/urls";
import { useUserStore } from "@/stores/user/user-store";
import { onMounted } from "vue";

export default {
  data() {
    return {
      authUrl: getAuthHostName(),
    };
  },
  setup() {
    const authStore = useAuthStore();
    const userStore = useUserStore();
    onMounted(() => {
      userStore.fetchStudents();
    });
    return {
      authStore,
      userStore,
    };
  },
};
</script>
